<template>
	<b-modal ref="profile_modal"
			 size="lg"
			 bodyClass="p-0"
			 v-bind:no-close-on-backdrop=true
			 :hide-header=true
			 v-model="is_show_modal"
			 :dialogClass=dialog_class_draw>

		<template v-slot:modal-header="{ close }">
			<!-- Emulate built in modal header close button action -->
			<b-button size="sm" variant="outline-danger" @click="close()">
				Close Modal
			</b-button>
		</template>

		<!-- BODY -->
		<div id="panel_user_list" class="panel mb-0 border-bottom-0 shadow-none">
			<div class="panel-hdr border-faded border-top-0 border-right-0 border-left-0 shadow-0">
				<h2 >
					<span class="fw-300">Користувач Exchange</span>
				</h2>
				<div class="panel-toolbar pr-3 pb-2 align-self-end">
					<button class="btn btn-panel bg-transparent fs-xl w-auto h-auto rounded-0 waves-effect waves-themed" v-on:click="close()">
						<i class="fal fa-times"></i>
					</button>
				</div>
			</div>

			<div class="panel-container show">

				<b-overlay :show="is_load" rounded="sm">
					<div class="panel-content">
						<div class="body_form">
							<div class="form-group mt-2">
								<label class="form-label" for="advanced_name">
									Логiн *
								</label>

								<div class="input-group flex-nowrap">
									<div class="input-group-prepend">
										<span class="input-group-text">
											<i class="fal  fa-typewriter fs-xl" ></i>
										</span>
									</div>
									<input id="advanced_name" type="text" class="form-control" v-model="user.user_name">
								</div>
							</div>

							<div class="form-group mt-2">
								<label class="form-label" for="advanced_name">
									Пароль*
								</label>

								<div class="input-group flex-nowrap">
									<div class="input-group-prepend">
										<span class="input-group-text">
											<i class="fal  fa-typewriter fs-xl" ></i>
										</span>
									</div>
									<input id="password" type="text" class="form-control" v-model="user.pass">
								</div>
							</div>

							<div class="form-group mt-2">
								<label class="form-label">
									Дозволи
								</label>

								<div class="input-group flex-nowrap">
									<b-form-radio-group
										id="btn-radios-1"
										v-model="user.userright"
										button-variant="outline-primary"
										:options="[
                                          { text: 'Read', value: 'r' },
                                          { text:  'Read/Write', value: 'rw' }
                                      ]"
										name="radios-btn-default"
										buttons
									></b-form-radio-group>
								</div>
							</div>

						</div>
					</div>
				</b-overlay>
			</div>
			<!--FOOTER -->
		</div>

		<template v-slot:modal-footer="{close}">
			<div class="modal-footer">
				<button type="button" @click="close()" class="btn btn-secondary waves-effect waves-themed">
					Закрити
				</button>

				<button type="button" v-on:click="save" class="btn btn-primary waves-effect waves-themed">
					Зберегти
				</button>
			</div>
		</template>
	</b-modal>
</template>

<script>
export default {
	name: "f_users_edit",
	props : {
		modal_position : {
			type : String,
			default : "right"
		},
		user_id : {
			type : Number,
			require : true
		}
	},
	data() {
		return {
			is_show_modal: false,
			is_load : false,
			user : {
				id : 0,
				user_name : "",
				pass : "",
				userright : "r",
			}
		}
	},

	created() {
		EventBus.$on("edit_exchange_user", this.work_click);
	},

	methods : {
		work_click(user) {
			if(this.obj_to_null(user)) {
				this.user = {...this.user,...user};
			}

			this.is_show_modal = true;
		},

		async save() {
			this.is_load = true;
			await api.put('/user/' + this.user_id + "/file_exchange/users/" + this.user.id,this.user).then(({data}) => {
				this.is_load = false;
				if(data.status === "operation_success") {
					EventBus.$emit('reload_exchange_users');
					this.close();
				}
			}).catch(({response}) => {
				this.is_load = false;
				EventBus.$emit('show_toast', {err: response.data.message,
					position : "b-toaster-top-left",
					type: "danger",
					title: response.data.status})
			});
		},

		close() {
			this.user = {
				id : 0,
				user_name : "",
				pass : "",
				userright : "r",
			};
			this.is_show_modal = false;
		},
	},
	computed : {
		dialog_class_draw () {
			if(this.modal_position === "left") {
				return "modal-dialog-left modal-lg";
			}

			return "modal-dialog-right modal-lg";
		},
	}
}
</script>

<style scoped>

</style>
